import React from 'react';
import styled from 'styled-components';
import { translate } from '../../../../../common/translation/translate';
import { AccessTimeIcon } from '../../../../common/icons/accessTimeIcon';

export const DayCardHourlyLinkLoadingUI = () => {
    return (
        <Container href='#'>
            <HourIconWrapper>
                <AccessTimeIcon width={15} height={15} />
            </HourIconWrapper>
            <Label>{translate('hourly')}</Label>
        </Container>
    );
};

const Container = styled.a`
    display: flex;
    padding: 6px;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #eee;
    text-decoration: none;
    background-color: #f9f9f9;
`;

const HourIconWrapper = styled.span`
    margin-right: 3px;
`;

const Label = styled.span`
    font-size: 14px;
    font-weight: 400;
    color: #aaa;
`;